import {
	UndefinedInitialDataOptions,
	queryOptions
} from '@tanstack/react-query'

import { ReservationDto } from '@wwt/entities/api/search-response'

import { getReservationQuery } from '../query/getReservationQuery.ts'

export const getReservationOptions = (
	offerId: string,
	otherParams: Omit<
		UndefinedInitialDataOptions<ReservationDto>,
		'queryKey' | 'queryFn'
	> = {}
) => {
	return queryOptions<ReservationDto>({
		// TODO: Create normal constants for Query IDs
		queryKey: ['get-reservation-by-offer-id', offerId],
		queryFn: ({ signal }) => getReservationQuery(offerId, signal),
		retry: () => false,
		...otherParams
	})
}
